import React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { getObjectValueByPath } from "../../../utils/ObjectUtils";
import { checkIsAdmin } from "../../../utils";

// Route guard matching FeatureRequired's sidebar gating, so a hidden menu cannot be
// reached by typing its URL. Compose inside RequireAuth:
//   component={RequireAuth(RequireFeature("fe.menu.view-orders")(ViewOrders))}
//
// FE-only: the role still holds the backend api permissions (DNA needs them), so this
// stops navigation, not API access.
// "wait" matters: features arrive from an async GET, so featuresObj is empty until it
// resolves. Denying on that would bounce users off their own pages on every hard reload.
export const featureRouteDecision = (
  { user, features, featuresObj },
  feature,
) => {
  if (checkIsAdmin(user)) return "allow";
  if (features === undefined) return "wait";
  return getObjectValueByPath(featuresObj || {}, feature) ? "allow" : "deny";
};

export default function (feature) {
  return function (ComposedComponent) {
    const RequireFeatureGuard = (props) => {
      const decision = featureRouteDecision(props, feature);

      if (decision === "wait") return null;
      if (decision === "deny") return <Redirect to="/agent" />;

      return <ComposedComponent {...props} />;
    };

    const mapState = ({ auth }) => ({
      features: auth.features,
      featuresObj: auth.featuresObj || {},
      user: auth.user || {},
    });

    return connect(mapState)(RequireFeatureGuard);
  };
}
